

<mat-card>
  <mat-card-content>

    <form [formGroup]="retentionFormGroup">
      <div>
        <div style="float:left;">
          <mat-form-field appearance="standard">
            <mat-label>Smooch messages retention duration (hours)</mat-label>
            <input #retentionHours type="text" [value]="retention" formControlName="hours" matInput placeholder="Smooch messages retention duration (hours)" required maxlength="4" />
          </mat-form-field>
        </div>
        <div >
          <button #btnSave mat-icon-button matTooltip="Save" matTooltipPosition="right" style="margin-top:15px; margin-left:20px">
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
